import theme from '@styles/theme';
export default {
  modal: {
    bg: theme.rawColors.neutralWhite,
    position: 'relative',
    width: '100%',
    height: '100%'
  },
  modalOverlay: {
    position: 'absolute'
  }
};